export default {
    env: 'production',
    buildNumber: '43',
    bugsnagApi: '838b7fa2b2e35729041cdcb9d032cdf8',
};
